import React from 'react';
import PosterCard from './PosterCard';
// import './MediaSection.css';

const MediaSection = ({ title, items }) => {
  return (
    <div className="media-section">
      <h2>{title}</h2>
      <div className="poster-scroll">
        {items.map((item, index) => (
          <PosterCard key={index} media={item} />
        ))}
      </div>
    </div>
  );
};

export default MediaSection;